import { AppLayout } from '../../layouts/app'
import ProfileOverview from './ProfileOverview'

export default function ProfilePage() {
  return (
    <AppLayout
      title={{
        messageDescriptor: {
          id: 'page.profile/page.title',
          defaultMessage: 'Profile',
        },
      }}
    >
      <ProfileOverview />
    </AppLayout>
  )
}
